import { SET_ID_LOGIN_ACTION } from "./reducersConstants";

export const setIdLoginAction = (data) => {
  return {
    type: SET_ID_LOGIN_ACTION,
    data,
  };
};

export const idLoginReducer = (previousState = "", { type, data }) => {
  switch (type) {
    case SET_ID_LOGIN_ACTION:
      return data;
    default:
      return previousState;
  }
};
